/* Recensioni Compro Oro: ordinamento, filtri, "mostra altre", apertura modulo */
(function () {
  function init(root) {
    if (root.dataset.rcoReady) return;
    root.dataset.rcoReady = '1';

    var grid = root.querySelector('[data-rco-grid]');
    var moreWrap = root.querySelector('[data-rco-more-wrap]');
    var moreBtn = root.querySelector('[data-rco-more]');
    var filters = root.querySelectorAll('[data-rco-filter]');
    var step = grid ? parseInt(grid.dataset.rcoInitial, 10) || 6 : 6;
    var limit = step;
    var current = 'tutte';

    if (grid) {
      // Più recenti per prime
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-rco-item]'));
      items.sort(function (a, b) {
        return (b.dataset.date || '').localeCompare(a.dataset.date || '');
      });
      items.forEach(function (el) { grid.appendChild(el); });
    }

    function render() {
      if (!grid) return;
      var shown = 0;
      var matching = 0;
      grid.querySelectorAll('[data-rco-item]').forEach(function (el) {
        var ok = current === 'tutte' || el.dataset.modalita === current;
        if (ok) matching++;
        var visible = ok && shown < limit;
        if (visible) shown++;
        el.hidden = !visible;
      });
      if (moreWrap) {
        var hasMore = matching > shown;
        moreWrap.hidden = !hasMore;
        moreWrap.style.display = hasMore ? '' : 'none';
      }
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        current = btn.dataset.rcoFilter;
        limit = step;
        filters.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        render();
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        limit += step;
        render();
      });
    }

    render();

    // Apertura / chiusura modulo
    var openBtn = root.querySelector('[data-rco-open]');
    var panel = root.querySelector('[data-rco-panel]');
    if (openBtn && panel) {
      openBtn.addEventListener('click', function () {
        var open = openBtn.getAttribute('aria-expanded') === 'true';
        openBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        panel.style.display = open ? 'none' : '';
        if (!open) {
          var first = panel.querySelector('input:not([type="hidden"]), textarea, select');
          if (first) first.focus();
        }
      });
    }

    // Link diretto al modulo: .../pages/compro-oro#recensione
    if (openBtn && panel && window.location.hash === '#recensione') {
      openBtn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.display = '';
      var cta = root.querySelector('.rco__cta') || panel;
      setTimeout(function () { cta.scrollIntoView({ block: 'start' }); }, 300);
    }

    // Dopo l'invio: porta in vista il messaggio di conferma
    var success = root.querySelector('[data-rco-success]');
    if (success) {
      success.scrollIntoView({ block: 'center' });
    }
  }

  function initAll() {
    document.querySelectorAll('.rco').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: reinizializza quando la sezione viene ricaricata
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.rco');
    if (root) init(root);
  });
})();
